import React from 'react';
import { Network } from 'lucide-react';
import TreeNode from './TreeNode';

export default function TreeHierarchyView({ orgTreeData, handleSelectTreeNode }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm overflow-x-auto min-h-[500px]">
      <div className="text-center mb-8">
        <h2 className="text-sm font-bold text-slate-800 uppercase tracking-wider flex items-center justify-center gap-2">
          <Network className="w-5 h-5 text-blue-600 animate-pulse" /> Vertical Organization Tree view
        </h2>
        <p className="text-xs text-slate-400 mt-1">
          Click a user node to immediately pull open their complete performance and biography dossier.
        </p>
      </div>

      <div className="flex flex-col items-center">
        {orgTreeData.map(rootNode => (
          <div key={rootNode.id} className="mb-12">
            <TreeNode node={rootNode} onSelect={handleSelectTreeNode} />
          </div>
        ))}
      </div>
    </div>
  );
}
